import React from "react";
import PropTypes from "prop-types";
import NewContractForm from "../NewContractForm";

function ContractDataStep({ memberType, memberData, contractData, onSubmit }) {
  return (
    <div>
      <NewContractForm
        memberType={memberType}
        memberData={memberData}
        contractData={contractData}
        handleContractDataSubmit={onSubmit}
      />
    </div>
  );
}

ContractDataStep.propTypes = {
  memberType: PropTypes.string,
  memberData: PropTypes.object,
  contractData: PropTypes.object,
  handleContractDataSubmit: PropTypes.func,
};

export default ContractDataStep;
